import { gql } from '@apollo/client';

export const DELETE_DESIGN = gql`
    mutation deleteDesign($designId: ID!){
        deleteDesign(designId: $designId){
            _id
            name
            marketPlaceType
            description
            featuredImage
            images
            design
            ownerId
        }
    }
`